import React, {useState, useEffect} from 'react';
import SectionInfoPromoExpired from '../section-info-promo-expired/section-info-promo-expired';
import SectionInfoPromo from '../section-info-promo/section-info-promo';
import SectionPromoReleated from '../section-promo-releated/section-promo-releated';
import './content-detail-promo.scss';

const ContentDetailPromo = props => {
    const { info } = props;
    const { tags, titulo} = info;
    
    const { fechaDeInicio, fechaDeFin } = info;
    const [expired, setExpired] = useState(false)
    
    let fechaS = fechaDeFin.split("-")
    let fechaFinFormat = new Date(`${fechaS[1]}/${fechaS[2]}/${fechaS[0]}`)
    let today = new Date()
    let todayFormat = new Date(`${today.getMonth()+1}/${today.getDate()}/${today.getFullYear()}`)
    
    useEffect(() => {
        HandleExpired()
    }, [])
    
    const HandleExpired = () => {              
       if(fechaFinFormat < todayFormat){
            setExpired(true)
       }      
    }
    return (
        <div>
            {
                expired ? 
                    <SectionInfoPromoExpired promo={ info } /> 
                    : 
                    <SectionInfoPromo promo={ info } />
            }
            <SectionPromoReleated promo={ info } />
        </div>
    )
}

export default ContentDetailPromo
